function UserPage() {
  return <h2>Willkommen Benutzer!</h2>;
}
export default UserPage;
